import React from "react";

const PrintTableOfContents = ({ disclaimer, issueItems }) => {
  const reportIntroEntries = [];

  if (disclaimer) {
    reportIntroEntries.push({
      label: "Inspection Scope & Disclaimer",
      anchor: "inspection-scope-disclaimer",
    });
  }
  reportIntroEntries.push({
    label: "Definitions & Glossary",
    anchor: "definitions-glossary",
  });

  const overviewSummaryEntries = [
    { label: "Inspection Overview", anchor: "inspection-overview" },
    { label: "Challenge Summary", anchor: "challenge-summary-section" },
  ];

  const inspectionEntries = [
    { label: "Property Details", anchor: "property-details" },
    ...(issueItems || []).map((section) => ({
      label: section.name,
      anchor: `section-${section.name?.toLowerCase().replace(/\s+/g, "-")}`,
    })),
  ];

  // Build sequential numbering across all categories
  let counter = 1;
  const numberedCategories = [
    reportIntroEntries,
    overviewSummaryEntries,
    inspectionEntries,
  ].map((entries) =>
    entries.map((entry) => ({ ...entry, number: counter++ }))
  );

  const renderCategory = (title, entries) => (
    <div className="print-toc-category">
      <div className="print-toc-category-title">{title}</div>
      {entries.map((entry) => (
        <a
          key={entry.anchor}
          href={`#${entry.anchor}`}
          className="print-toc-entry"
        >
          <span className="print-toc-entry-number">{entry.number}.</span>
          <span className="print-toc-entry-label">{entry.label}</span>
        </a>
      ))}
    </div>
  );

  return (
    <div className="print-toc-container" id="print-toc">
      <h1 className="print-toc-title">Table of Contents</h1>
      {renderCategory("REPORT & INTRODUCTION", numberedCategories[0])}
      {renderCategory("OVERVIEW & SUMMARY", numberedCategories[1])}
      {renderCategory("INSPECTION", numberedCategories[2])}
    </div>
  );
};

export default PrintTableOfContents;
